import { z } from 'zod';

export const scheduleEditorDataSchema = z.object({
	format: z.enum(['v1']).optional().default('v1'),
	schedule: z
		.object({
			name: z.string(),
		})
		.partial()
		.optional(),
	year: z
		.object({
			name: z.string(),
			startDate: z.string(),
			endDate: z.string(),
			terms: z.array(
				z.object({
					name: z.string(),
					startDate: z.string(),
					endDate: z.string(),
				})
			),
		})
		.partial()
		.optional(),
	regularDays: z
		.array(
			z
				.object({
					name: z.string(),
					periods: z.array(
						z.object({
							name: z.string(),
							startTime: z.string(),
							endTime: z.string(),
						})
					),
				})
				.partial()
		)
		.optional(),
});
export type ScheduleEditorData = z.infer<typeof scheduleEditorDataSchema>;

export const scheduleEditorProgressSchema = z.object({
	id: z.number(),
	version: z.number(),
	school_id: z.number(),
	data: scheduleEditorDataSchema,
	updated_at: z.string(),
	updated_by: z.number(),
	deleted_at: z.string().nullable(),
});
export type ScheduleEditorProgress = z.infer<typeof scheduleEditorProgressSchema>;

export const createProgressRequestSchema = z.object({ data: scheduleEditorDataSchema });
export type CreateProgressRequest = z.infer<typeof createProgressRequestSchema>;

export const createProgressResponseSchema = z.object({ progress: scheduleEditorProgressSchema });
export type CreateProgressResponse = z.infer<typeof createProgressResponseSchema>;

export const listProgressRequestSchema = z.object({});
export type ListProgressRequest = z.infer<typeof listProgressRequestSchema>;

export const listProgressResponseSchema = z.object({ progress: z.array(scheduleEditorProgressSchema) });
export type ListProgressResponse = z.infer<typeof listProgressResponseSchema>;

export const updateProgressRequestSchema = z.object({
	id: z.number(),
	data: scheduleEditorDataSchema,
});
export type UpdateProgressRequest = z.infer<typeof updateProgressRequestSchema>;

export const updateProgressResponseSchema = z.object({ progress: scheduleEditorProgressSchema });
export type UpdateProgressResponse = z.infer<typeof updateProgressResponseSchema>;
